export const SearchResultsCTA = {
  "pageName": "",
  "pageUrl": "",
  "SearchTerm": "",
  "SearchResults": "",
  "Search Category": "",
  "Label": "",
  "itemCount": "0",
  "pageCategory": "",
};